import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { AnyObject, ObjectWithId } from '../../types/common';
import { locationChange } from '../router/actions';
import { detachFromTree } from '../tree/utils';
import type { ModalsManagerAppState } from './types';

export type OpenModalPayload = {
  /**
   * Modal ID.
   */
  id: string;
  contextItems?: ObjectWithId[];
  options?: AnyObject;
};

const initialState: ModalsManagerAppState = {};

export const modalsManagerSlice = createSlice({
  name: 'modals_manager',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<OpenModalPayload>) => {
      const { id, contextItems, options } = action.payload;
      state[id] = {
        ...state[id],
        contextItems: contextItems && detachFromTree(contextItems),
        options,
        isOpen: true,
      };
    },
    closeModal: (state, action: PayloadAction<{ id: string }>) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        isOpen: false,
        closing: true,
      };
    },
    clearClosingModal: (state, action: PayloadAction<{ id: string }>) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        closing: false,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(locationChange, () => initialState);
  },
});

export const { openModal, closeModal, clearClosingModal } =
  modalsManagerSlice.actions;

export const modalsManagerReducer = modalsManagerSlice.reducer;
